import type { IllustrationMap } from '@/components/Illustration/types'
import { SuccessIcon } from '@/components/Icons/SuccessIcon'

export const ikanoIllustrations: Partial<IllustrationMap> = {
  success: {
    component: SuccessIcon,
    fillColor: 'var(--icon-custom-color)',
  },
}
